/* globals $ appSettings */

/**
 * This http service is an abstraction of the used AJAX implementation.
 * When fully integrated, it will make development easier when swapping
 * AJAX implementation if desired (i.e. from jQuery to Axios).
 *
 * @author Erik Noorland
 */

import logger from '../components/logger';

/**
 * Http
 * @return {Object}
 */
const http = () => {
  const methodsNoData = ['get', 'delete'];
  const methodsData = ['post', 'patch', 'put'];

  let returnObject = {};

  /**
   * Constructor
   */
  function constructor() {
    $.ajaxSetup({
      beforeSend(xhr, settings) {
        xhr.setRequestHeader('Accept', 'application/vnd.onefit.v2.1+json');
        xhr.setRequestHeader('X-ONEFIT-CLIENT', `website/${appSettings.buildVersion}`);

        if (settings.contentType !== false) {
          xhr.setRequestHeader('Content-Type', 'application/json');
        }

        if (appSettings.authorizationHeader) {
          xhr.setRequestHeader('Authorization', `Bearer ${appSettings.authorizationHeader}`);
        }
      },
    });

    returnObject = Object.assign({},
      methodsNoData.reduce(createNoDataMethods, returnObject),
      methodsData.reduce(createDataMethods, returnObject),
    );
  }

  /**
   * Returns an object with the given method (no data)
   * @param {Object} acc
   * @param {String} method
   * @return {Object}
   */
  function createNoDataMethods(acc, method) {
    acc[method] = (url, params = {}) => request(url, method.toUpperCase(), params);

    return acc;
  }

  /**
   * Returns an object with the given method (data)
   * @param {Object} acc
   * @param {String} method
   * @return {Object}
   */
  function createDataMethods(acc, method) {
    acc[method] = (url, data = {}) => request(url, method.toUpperCase(), data);
    acc[`${method}JSON`] = (url, data = {}) => acc[method](url, JSON.stringify(data));

    return acc;
  }

  /**
   * Returns a promise while initiating an ajax request
   * @param {String} url
   * @param {String} method
   * @param {Object} data
   * @return {Promise}
   */
  function request(url, method, data = {}) {
    const options = { method, data };

    logger.notice(`HTTP ${method} - ${url}`);

    return new Promise((resolve, reject) => {
      $.ajax(url, options)
        .done(response => resolve(response))
        .fail(response => reject(response.responseJSON));
    });
  }

  constructor();

  return returnObject;
};

export default http();



// WEBPACK FOOTER //
// ./resources/assets/js/utils/http.js